import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';
import type {
  DateSummaryInfoForHotels,
  DateSummaryInfoForTours,
  HotelSummaryInfo,
} from '../../types';
import HotelInfo from './components/HotelInfo';
import HotelNightsCount from './components/HotelNightsCount';
import TourNightsCount from './components/TourNightsCount';

type ToursOnlyProps = {
  hotel: HotelSummaryInfo;
  dates: DateSummaryInfoForTours;
  isHotelOnly: false;
  onClick: () => void;
  touristsText: string;
};

type HotelOnlyProps = {
  hotel: HotelSummaryInfo;
  dates: DateSummaryInfoForHotels;
  isHotelOnly: true;
  onClick: () => void;
  touristsText: string;
};

const HotelSummary = (props: ToursOnlyProps | HotelOnlyProps) => {
  const { t } = useTranslation();
  const { hotel, dates, touristsText, isHotelOnly, onClick } = props;

  return (
    <Wrapper>
      {!isHotelOnly && <Title>{t('checkout.summary.hotel.title')}</Title>}
      {isHotelOnly ? (
        <HotelNightsCount
          startDate={dates.startDate}
          endDate={dates.endDate}
          nights={dates.nights}
          checkInTime={dates.checkInTime}
          checkOutTime={dates.checkOutTime}
        />
      ) : (
        <TourNightsCount
          startDate={dates.startDate}
          endDate={dates.endDate}
          nights={dates.nights}
          originalNights={dates.originalNights}
        />
      )}
      <HotelInfo hotel={hotel} onClick={onClick} />
      <TouristsText>{touristsText}</TouristsText>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 8px;
  font-size: 14px;

  > * + * {
    margin-top: 8px;
  }
`;

const Title = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #919499;
`;

const TouristsText = styled.div`
  color: #4d4d4d;
`;

export default HotelSummary;
